export const ACCOUNT_REFERRAL_TYPE = {
  ACCOUNT_SIGNUP: 'ACCOUNT_SIGNUP',
  SHUTTERBUG_PROMO: 'SHUTTERBUG_PROMO',
  WALDOGRAM_PROMO: 'WALDOGRAM_PROMO',
  TIER_1_SHUTTERBUG_PROMO: 'TIER_1_SHUTTERBUG_PROMO',
  TIER_1_WALDOGRAM_PROMO: 'TIER_1_WALDOGRAM_PROMO',
  ONE_FREE_WALDOGRAM: 'ONE_FREE_WALDOGRAM',
  PHOTO_MANAGER_YEARLY_50_PC_OFF_ONCE: 'PHOTO_MANAGER_YEARLY_50_PC_OFF_ONCE',
  WEDDINGS_50_USD_OFF: 'WEDDINGS_50_USD_OFF',
  WEDDINGS_100_PC_OFF_ONCE: 'WEDDINGS_100_PC_OFF_ONCE',
  WEDDINGS: 'WEDDINGS',
  PHOTO_MANAGER_MONTHLY: 'PHOTO_MANAGER_MONTHLY',
  PHOTO_MANAGER_YEARLY: 'PHOTO_MANAGER_YEARLY',
  PRINTS: 'PRINTS',
  SUBSCRIPTIONS: 'SUBSCRIPTIONS',
  EVENTS: 'EVENTS',
  PHOTO_FINDER_MONTHLY: 'PHOTO_FINDER_MONTHLY',
  PHOTO_FINDER_YEARLY: 'PHOTO_FINDER_YEARLY',
  PLIC_PRO_SIGNUP: 'PLIC_PRO_SIGNUP',
  PRINT_PARTNER: 'PRINT_PARTNER',
  PLUS_MONTHLY: 'PLUS_MONTHLY',
  PLUS_YEARLY: 'PLUS_YEARLY',
  PRO_PRODUCTS: 'PRO_PRODUCTS',
  DIGITAL_DOWNLOADS: 'DIGITAL_DOWNLOADS',
};

export const ACCOUNT_REFERRAL_TYPE_HEADERS = {
  ACCOUNT_SIGNUP: 'Refer a friend and get your share of their purchases!',
  SHUTTERBUG_PROMO: 'Let the photo sharing begin!',
  WALDOGRAM_PROMO: 'Waldograms for everyone!',
  TIER_1_SHUTTERBUG_PROMO: 'Let the photo sharing begin!',
  TIER_1_WALDOGRAM_PROMO: 'Refer a friend and earn Waldograms!',
};

export const ACCOUNT_REFERRAL_TYPE_DESCRIPTIONS = {
  ACCOUNT_SIGNUP:
    'Earn a share of all Waldograms and Shutterbug subscription of new users you refer to Waldo!',
  SHUTTERBUG_PROMO: 'Earn 10GB of storage for everyone who subscribes!',
  WALDOGRAM_PROMO:
    "Earn a FREE Waldogram when your friend sends their first Waldogram. They'll get a FREE Waldogram too!",
  TIER_1_SHUTTERBUG_PROMO:
    'Share 30 days of FREE Waldo Plus with friends & family',
  TIER_1_WALDOGRAM_PROMO:
    "Earn a FREE Waldogram for each friend who sends their first Waldogram. They'll get a FREE Waldogram too!",
};
